import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { useSearchParams } from 'react-router';
import { SearchResults } from 'features/global-search';
import { useGlobalSearchPageNavigation } from './hooks';

const PageGlobalSearch = () => {
  const onNavigate = useGlobalSearchPageNavigation();
  const { scope } = useRequiredParams<{ scope: string }>();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('query') ?? undefined;

  return (
    <AppLayout>
      <SearchResults onNavigate={onNavigate} query={query} scope={scope} />
    </AppLayout>
  );
};

export default PageGlobalSearch;
